import type { ClientLayout } from '@/types/theme'

/** Opt-in only: unknown/missing values retain the existing mobile panes. */
export function usesMobileAgentDrawer(layout?: Pick<ClientLayout, 'mobileAgentPresentation'>): boolean {
  return layout?.mobileAgentPresentation === 'drawer'
}

export function usesMobileAgentSwipe(layout?: Pick<ClientLayout, 'mobileAgentPresentation'>): boolean {
  return layout?.mobileAgentPresentation === 'swipe'
}

export function initialMobileAgentSurface(
  agentEnabled: boolean,
  pageFirst: boolean,
  hasThread: boolean,
): 'chat' | 'page' {
  return agentEnabled && (!pageFirst || hasThread) ? 'chat' : 'page'
}
